import { useTranslation } from 'react-i18next'

import { OrderingMenu } from 'components/ordering/OrderingMenu'
import { TypeRoute } from 'core/TypeRoute'
import { useCartButton, useCurrentStore } from 'hooks'
import { useEffect, useMemo } from 'react'
import { generatePath } from 'react-router-dom'

export const OrderingPage = () => {
  const { t } = useTranslation()

  const { showCartButton } = useCartButton()
  useEffect(() => showCartButton(), [showCartButton])

  const { store } = useCurrentStore()

  const breadcrumbs = useMemo(
    () => [
      { label: t('Stores') },
      {
        label: store?.name ?? '',
        to: generatePath(TypeRoute.StoreInfo, { storeId: store?.id ?? '' }),
      },
      { label: t('Ordering') ?? '' },
    ],
    [store, t],
  )

  return <OrderingMenu breadcrumbs={breadcrumbs} />
}
